import classNames from "classnames";
import type { ReactNode } from "react";

interface PageProps {
  children: ReactNode;
  className?: string;
  title?: string;
  description?: string;
}

export function Page({ children, className }: PageProps) {
  return <div className={classNames("page active", className)}>{children}</div>;
}
